import anime from 'animejs';
import App from './app';
import { isMobile } from './helpers';

class Loader {
	constructor(skipLoading: boolean = false) {
		if (skipLoading) {
			document.querySelector('.we-are.loading').remove();
			new App();
		} else {
			this.handleLoader();
		}
	}

	app: App;

	handleLoader() {
		const sidebar = document.getElementById('sidebar');

		const loadingAnim = anime.timeline({
				loop: false
			})
			.add({
				targets: [`.we-are.loading > svg`],
				scale: [5, 1],
				opacity: [0, 1],
				easing: "easeOutExpo",
				duration: 800,
				delay: 100
			})
			.add({
				targets: '.we-are.loading > div span',
				translateX: [40, 0],
				translateZ: 0,
				opacity: [0, 1],
				easing: "easeOutExpo",
				duration: 600,
				delay: function (el, i) {
					return 80 + 30 * i;
				}
			}).add({
				targets: '.we-are.loading > div span',
				translateX: [0, -30],
				opacity: [1, 0],
				easing: "easeInExpo",
				duration: 300,
				delay: function (el, i) {
					return 80 + 30 * i;
				}
			})
			.add({
				targets: [`.we-are.loading > svg`],
				// scale: [1, 20],
				translateX: [0, 400],
				rotate: [0, 360],
				opacity: [1, 0],
				easing: "cubicBezier(.5, .05, .1, .3)",
				duration: 300,
				delay: 80,
			})
			.add({
				targets: [`.we-are.loading`],
				translateX: [0, `calc(100% - ${sidebar ? sidebar.clientWidth + 'px' : 0})`],
				// translateX: [0, `100%`],
				// translatey: [0, '-100%'],
				// borderRadius: [0, '100%'],
				// opacity: [1, 0],
				easing: "easeInOutCubic",
				duration: 900,
				delay: 80,
				begin: e => {
					const anim = anime({
						targets: ['.we-are.ready'],
						translateX: [-420, 0],
						translateZ: 0,
						opacity: [0, 1],
						easing: "easeOutExpo",
						duration: 500,
						delay: 350
					});
				},
				update: e => {
					// dont add delay on mobile
					if (isMobile) {
						if (!this.app) {
							this.app = new App();
						}

						return;
					}

					if ((e.duration - e.currentTime) <= 600) {
						if (!this.app) {
							this.app = new App();

							// const finishAnim = anime.timeline({
							// 	loop: false,
							// })
							// .add({
							// 	targets: [`.we-are.loading`],
							// 	opacity: [1, 0],
							// 	duration: 400,
							// 	delay: 0
							// }).finished.then(() => {
							// 	document.querySelector('.we-are.loading').remove();
							// });
						}
					}
					// 	shouldFinish = true;

					// 	if (shouldFinish) {
					// 		startedFinish = true;

					// 		console.log('<')
					// 		console.log(loadingAnim)
					// 		console.log(loadingAnim.currentTime)
					// 		console.log(loadingAnim.duration)
					// 		console.log(loadingAnim.duration - loadingAnim.currentTime === 100)
					// 		console.log('/>')

					// 		return;
					// 	}
					// }
				}
			})
			// .add({
			// 	targets: null,
			// 	delay: 0,
			// // 	begin: function(anim) {
			// 	const anim = anime({
			// 		targets: ['.we-are.ready'],
			// 		translateX: [-420, 0],
			// 		translateZ: 0,
			// 		opacity: [0, 1],
			// 		easing: "easeOutExpo",
			// 		duration: 500,
			// 		delay: 0
			// 	});
			// // 		console.log('fopo')
			// // 		new App();
			// // 	}
			// }, '200ms')
			.add({
				targets: [`.we-are.loading`],
				opacity: [1, 0],
				duration: 400,
				delay: 0,
			}).finished.then(() => {
				document.querySelector('.we-are.loading').remove();
			});

		// loadingAnim.
		// const finishAnim = anime.timeline({
		// 	loop: false,
		// })
		// .add({
		// 	targets: [`.we-are.loading`],
		// 	opacity: [1, 0],
		// 	duration: 400,
		// 	delay: loadingAnim.remaining
		// })
	}
}

export default Loader;
export { Loader };
